module.exports = __webpack_public_path__ + "img/4_39.6eac3433.png";